module.exports = __webpack_public_path__ + "fonts/Calibre-Medium.46b36969.woff2";